module.exports = __webpack_public_path__ + "static/media/berkeley-mobile@3x.893f3404.png";